'use client';
var classes = {"root":"m_849cf0da"};

export { classes as default };
//# sourceMappingURL=Anchor.module.css.mjs.map
